import { render } from "./home-popularcities.vue?vue&type=template&id=44522e44"
import script from "./home-popularcities.js?vue&type=script&lang=js"
export * from "./home-popularcities.js?vue&type=script&lang=js"

import "./home-popularcities.vue?vue&type=style&index=0&id=44522e44&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__